<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    parentModelName="risk_template"
    parentLabel=""
    parentTitleKey="last_version.name"
    :parentId="$route.params.id"
    :customParentData="customParentData"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/change_item_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    customParentData: (parentData) => {
      return {
        area: parentData.area,
      };
    },
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "變因資訊",
              fields: ["last_version"],
              createHideFields: ["last_version"],
              link: {
                btnName: "點此前往新增",
                alertTitle: "確認要前往新增變動評估項目嗎？",
                hint: "找不到需要的風險評估項目嗎？",
                path: `/risk_template/create`,
              },
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "分類設定",
              fields: [
                "areas",
                "industry_categories",
                "range_type",
                "factories",
                "exclusive_factories"
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "顯示設定",
              remark: "隱藏的內容將不會顯示於使用者前台介面",
              fields: ["is_active"],
            },
          ],
        },
      ],
    },
  }),
};
</script>